import { QueryClient } from "@tanstack/react-query";

export const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      staleTime: 1000 * 60 * 1,
      gcTime: 1000 * 60 * 10,
      retry: 1,
      // Refetching on every window focus re-churned the `/users/me` object
      // (its payload includes a live `balance.spendingPower`), defeating the
      // setUserFromMe guard and triggering a re-render/remount storm. Disable it.
      refetchOnWindowFocus: false,
      refetchOnMount: true,
      refetchOnReconnect: true,
    },
  },
});
